import React from "react";
import { makeStyles } from "@material-ui/core/styles";

export default function ImageContainer({ children, label, marginBottom }) {
  const useStyles = makeStyles({
    wrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      width: "100%",
      marginBottom: marginBottom ? marginBottom : 0
    },
    logoContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "stretch",
      justifyContent: "center",
      padding: "20px 0",
    },
    logoText: {
      color: "#000",
      fontWeight: "700",
      textAlign: "center",
    },
  });
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <div className={classes.logoContainer}>{children}</div>
      <strong className={classes.logoText}>{label}</strong>
    </div>
  );
}
